import React, { useEffect, useState } from 'react';
import './StartScreen.scss';
import Lottie from 'lottie-react';
import welcomeTextAnim from './Assets/welcomeTextAnim.json';
import { Preloader } from '../Preloader/Preloader';
import { useMusic } from '../../contexts/MusicContext';

interface StartScreenProps {
  onHidden: () => void;
  isSceneLoaded: boolean;
}

const StartScreen: React.FC<StartScreenProps> = ({ onHidden, isSceneLoaded }) => {
  const [isHiding, setIsHiding] = useState(false);
  const { setIsPlaying } = useMusic();
  const [isPreloaderFinished, setIsPreloaderFinished] = useState(false);

  const handleEnterClick = (music: boolean) => {
    setIsHiding(true);
    setTimeout(() => {
      onHidden();
      setIsPlaying(music);
    }, 1000);
  };

  const handlePreloaderFinish = () => {
    setIsPreloaderFinished(true);
  };

  const searchParams = new URLSearchParams(window.location.search);
  const showPreloader = searchParams.get('preloader') === 'true';

  if (showPreloader && !isPreloaderFinished) {
    return <Preloader
      isSceneLoaded={isSceneLoaded}
      onFinish={handlePreloaderFinish}
    />;
  }

  if (!showPreloader) {
    return (
      <div className={`start-screen ${isHiding ? 'fade-out' : ''}`}>
        {!isPreloaderFinished ? (
          <Preloader
            isSceneLoaded={isSceneLoaded}
            onFinish={handlePreloaderFinish}
          />
        ) : (
          <>
            <div className="content">
              <Lottie
                animationData={welcomeTextAnim}
                loop={false}
                autoplay={true}
                className="fade-in"
              />
              <h1 className="title fade-in">
                MUSEUM OF DIGITAL INFLUENCE
              </h1>
              <p className="description fade-in">
                Capturing the key moments, innovations, and trends that have defined how we connect and
                influence online – from the rise of blogging to today.
              </p>

              <button
                className="btn enter-btn fade-in"
                onClick={() => handleEnterClick(true)}
              >
                ENTER
              </button>
              <div className="without-music fade-in" onClick={() => handleEnterClick(false)}>
                Enter without music
              </div>
            </div>
            <footer className="credits fade-in">
              <div className="created-by">
                CREATED BY <a href="https://zorka.agency/" target="_blank" className="author">ZORKA.AGENCY</a>
              </div>
              <div className="designed-by">
                DESIGNED BY <a href="https://www.niwart.io/" target="_blank" className="designer">NIWART</a>
              </div>
            </footer>
          </>
        )}
      </div>
    );
  }

  return null;
};

export default StartScreen;
